import React from "react";

//react-slick
import Slider from "react-slick";

//material ui
import { useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";

//json2mq
import json2mq from "json2mq";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    width: isMobile ? "80%" : "100%",
    height: "224px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    marginTop: isMobile ? "56px" : "96px",
  },
  slider: {
    display: "flex",
    maxWidth: "100%",
  },
  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrow: {
    color: theme.palette.grey.main,
    fontSize: "30px",
    fontWeight: "bold",
  },
});

const TechnologiesCarrousel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { imgs, alt } = useTranslation(pathname, "TechnologiesCarrousel");

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );

  const md = useMediaQuery(
    json2mq({
      maxWidth: 1200,
      minWidth: 900,
    })
  );

  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1201,
    })
  );

  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
    })
  );

  const stylesHelper = () => {
    if (xs)
      return {
        img: {
          margin: "16px auto",
          height: "4.5rem",
          width: "4.5rem",
          objectFit: "contain",
        },
      };
    else if (lg || xl)
      return {
        img: {
          margin: "16px auto",
          height: "5rem",
          width: "5rem",
          objectFit: "contain",
        },
      };
    else if (md)
      return {
        img: {
          margin: "16px auto",
          height: "5rem",
          width: "5rem",
          objectFit: "contain",
        },
      };
  };

  return (
    <div style={classes.container}>
      {stylesHelper() && (
        <Slider
          autoplay={true}
          autoplaySpeed={2000}
          swipeToSlide={true}
          infinite={true}
          slidesToShow={isMobile ? 2 : 3}
          rows={2}
          style={classes.slider}
        >
          {imgs.map((img, index) => {
            return (
              <div key={`${alt} ${index}`}>
                <img
                  src={img}
                  alt={`${alt} ${index}`}
                  style={stylesHelper().img}
                />
              </div>
            );
          })}
        </Slider>
      )}
    </div>
  );
};

export default TechnologiesCarrousel;
